import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import AdvancedAlertsContent from "components/pages/AdvancedAlertsPage/components/AdvancedAlertsContent";

export default function CaptureNotifiLegacySuccessfullyVerified(props) {
    const dataObj = { verified: true };
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    // Sets the component to be used for the content
    .update([ "contentData" ], dataObj)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], AdvancedAlertsContent)
    .submit();
    
    return <AdvancedAlertsPage data={ data } ui={ ui } />
}